import './ViewAuditioneesTab2.css';

import { useEffect, useState } from "react";
import { getAllDataFrom } from "../../../../_shoru_shared_library/firebase/firebase_setup";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import { GetClashBotData } from "./helpers/GetClashBotData";
import GetRegister from "../../../functions/GetRegister";
import FormButton from "../../../../_shoru_shared_library/components/form/FormButton";

import { AnimatePresence, motion } from "motion/react";


export function ViewAuditioneesTab2(props) {

  const userData = props.userData;
  const castingData = props.extraData;
  const projectData = props.projectData;
  const season = props.additional.season;

  const [auditionees, setAuditionees] = useState(null);
  const [duplicates, setDuplicates] = useState(null);

  // Get auditionee data
  useEffect(() => {
    async function GetAuditionees() {
      let rawAuditionees;
      await getAllDataFrom(userData.active_organisation_id, 'castingbot', 'auditionees', (x) => {rawAuditionees = x});
      ProcessAuditionees(rawAuditionees, setAuditionees, setDuplicates);
    }
    GetAuditionees();
    // eslint-disable-next-line
  }, []);

  const getMergedEntry = (entry) => {
    const names = new Set(entry.map((x) => x.name));
    const phones = new Set(entry.map((x) => x.phone));
    const emails = new Set(entry.map((x) => x.email));
    const uids = new Set(entry.map((x) => x.uid));
    return {
      uids: [...uids],
      names: [...names],
      emails: [...emails],
      phones: [...phones]
    }
  }

  const handleMerge = (entry, index) => {
    const mergedEntry = getMergedEntry(entry);
    setAuditionees((prev) => [...prev, mergedEntry])
    const newDuplicates = duplicates.filter((_, i) => i !== index);
    setDuplicates(newDuplicates);
  }

  const handleDontMerge = (entry, index) => {
    let newAuditionees = entry.map((x) => {
      return {
        uids: [x.uid],
        names: [x.name],
        emails: [x.email],
        phones: [x.phone]
      }
    });
    setAuditionees((prev) => [...prev, ...newAuditionees]);
    setDuplicates((prev) => prev.splice(index, 1));
    const newDuplicates = duplicates.filter((_, i) => i !== index);
    setDuplicates(newDuplicates);
  }

  const handleContinue = () => {
    let finalAuditionees = structuredClone(auditionees);

    // If there are any remaining duplicates, merge them
    if(duplicates.length) {
      duplicates.forEach((entry) => {
        const mergedEntry = getMergedEntry(entry);
        finalAuditionees = [...finalAuditionees, mergedEntry];
      })
    }

    props.additional.setAuditionees(finalAuditionees)
    const clashBotData = GetClashBotData(castingData, projectData, finalAuditionees, season);
    props.additional.setClashBotData(clashBotData);
    GetRegister(clashBotData, props.additional.setClashBotData, props.additional.setRegister);
  }

  if(!auditionees || !duplicates) return <SectionLoader />

  return (
    <SubTabParent passData={props}>
      <SubTabSection>
        <h2>{duplicates.length ? 'Duplicates Found' : 'No Duplicates'}</h2>
        <p>{duplicates.length ? 'ClashBot has detected multiple auditionees using the same details. Duplicates should be merged to avoid casting errors.' : 'No duplicated auditionees were found.'}</p>
        <FormButton accentColour={props.accentColour} label={duplicates.length ? 'Merge All & Continue' : 'Continue'} onClick={handleContinue}/>
      </SubTabSection>
      <SubTabSection no_background>
        <div className='duplicate-row-container'>
          <AnimatePresence>
          {
            duplicates.map((d, i) => 
              <motion.div 
                key={d.map(a => a.uid).join("-")}
                initial={{opacity: 1}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
                transition={{duration: 0.25}}
              >
                <DuplicateRow entry={d} index={i} handleDontMerge={handleDontMerge} handleMerge={handleMerge} />
              </motion.div>
            )
          }

          </AnimatePresence>
        </div>
      </SubTabSection>
    </SubTabParent>
  )

}


function DuplicateRow({entry, index, handleMerge, handleDontMerge}) {

  function isDuplicated(array, item) { return array.filter(x => x === item).length > 1; }
  function getColour(array, item) { return isDuplicated(array, item) ? '#3498db' : '#aaa'; }

  const names = entry.map((x) => x.name);
  const phones = entry.map((x) => x.phone);

  return (
    <div className='duplicate-row'>
      <div className='duplicate-controls'>
        <p>Are these the same person?</p>
        <div>
          <p onClick={() => handleDontMerge(entry, index)}>Don't Merge</p>
          <button onClick={() => handleMerge(entry, index)} style={{backgroundColor: '#2ecc71'}}>Merge</button>
        </div>
      </div>
      <div className='duplicate-auditionee-container'>
        {
          entry.map((auditionee) => 
            <div key={auditionee.uid} className='duplicate-auditionee'>
              <b className='duplicate-auditionee-name' style={{color: getColour(names, auditionee.name)}}>{auditionee.name}</b>
              <div style={{color: getColour(phones, auditionee.phone)}}>{auditionee.phone}</div>
              <hr/>
              <div className='duplicate-auditionee-email'>{auditionee.email}</div>
            </div>
          )
        }
      </div>
    </div>
  )
}


function ProcessAuditionees(raw, setAuditionees, setDuplicates) {

  let duplicates = [];
  let auditionees = [];
  let visited = new Set();

  raw.forEach((auditionee, i) => {
    if(visited.has(i)) return;

    const group = [auditionee];

    raw.forEach((other, j) => {
      if(i === j || visited.has(j)) return;

      const duplicate = 
        auditionee.name === other.name ||
        auditionee.email === other.email ||
        auditionee.phone === other.phone;

      if(duplicate) {
        group.push(other);
      }
    });

    if(group.length > 1) {
      group.forEach(member => {
        const index = raw.indexOf(member);
        visited.add(index);
      });
      duplicates.push(group);
    }
    else {
      visited.add(i);

      auditionees.push({
        names: [auditionee.name],
        uids: [auditionee.uid],
        emails: [auditionee.email],
        phones: [auditionee.phone]
      });
    }
  })

  setAuditionees(auditionees);
  setDuplicates(duplicates);
}